import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { LOGO_URL } from '../data/navigation';
export function SignupPage() {
  const [showPassword, setShowPassword] = useState(false);
  return <main className="min-h-screen w-full flex bg-stark-white" data-id="element-389" data-mp="98e59dzfanlt">
      {/* Left Side - Form */}
      <div className="flex-1 flex flex-col justify-center px-6 py-12 lg:px-20 xl:px-32 relative" data-id="element-390" data-mp="3hno1i5gmsylo">
        <Link to="/" className="absolute top-8 left-6 lg:left-20 xl:left-32" data-id="element-391" data-mp="3cq4of8vo6rvb">
          <img src={LOGO_URL} alt="ROI Complete" className="h-12 md:h-14 w-auto" data-id="element-392" data-mp="3qovzemf8jxf8" />
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="w-full max-w-md mx-auto" data-id="element-393" data-mp="3lqawugcih1nm">
          <div className="space-y-2 mb-10" data-id="element-394" data-mp="1102a7ffvg7um">
            <h1 className="text-3xl md:text-4xl font-montserrat font-extrabold text-midnight-navy tracking-tight" data-id="element-395" data-mp="10zafs7y0gg5x">
              Create an account
            </h1>
            <p className="text-midnight-navy/60" data-id="element-396" data-mp="278gsv1s3cerv">
              Start optimizing your operations and increasing profitability today.
            </p>
          </div>

          <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-397" data-mp="2c6a0lz91lgu9">
            <div className="space-y-2" data-id="element-398" data-mp="2h6ei9sloshm2">
              <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/60 ml-1" data-id="element-399" data-mp="1jjp8gwkqt0pn">
                Full Name
              </label>
              <input required type="text" className="w-full px-5 py-4 bg-cool-gray border border-midnight-navy/10 rounded-xl focus:outline-none focus:border-royal-blue transition-colors" placeholder="Jane Doe" data-id="element-400" data-mp="1oj1szao55vp2" />
            </div>

            <div className="space-y-2" data-id="element-401" data-mp="10so1pmdds0vj">
              <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/60 ml-1" data-id="element-402" data-mp="15rr7j916qb4k">
                Email Address
              </label>
              <input required type="email" className="w-full px-5 py-4 bg-cool-gray border border-midnight-navy/10 rounded-xl focus:outline-none focus:border-royal-blue transition-colors" placeholder="name@company.com" data-id="element-403" data-mp="xpi89c6y5e8h" />
            </div>

            <div className="space-y-2" data-id="element-404" data-mp="12kdz490g5vk0">
              <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/60 ml-1" data-id="element-405" data-mp="erp4k7oi10a1">
                Password
              </label>
              <div className="relative" data-id="element-406" data-mp="asyhktdqyz0n">
                <input required type={showPassword ? 'text' : 'password'} className="w-full px-5 py-4 bg-cool-gray border border-midnight-navy/10 rounded-xl focus:outline-none focus:border-royal-blue transition-colors pr-12" placeholder="••••••••" data-id="element-407" data-mp="or6amq7nxg6j" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-midnight-navy/40 hover:text-midnight-navy transition-colors" data-id="element-408" data-mp="1v673uo5azk9f">
                  {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-409" data-mp="345qhmebfq7ox" /> : <EyeIcon className="w-5 h-5" data-id="element-410" data-mp="393a584u0vwtj" />}
                </button>
              </div>
            </div>

            <button type="submit" className="w-full bg-royal-blue text-stark-white py-4 rounded-xl font-bold hover:bg-royal-blue-dark transition-all shadow-lg shadow-royal-blue/20 flex items-center justify-center gap-2 group mt-2" data-id="element-411" data-mp="pb0oeszj34f">
              Create Account
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-412" data-mp="3rz9rr048e85q" />
            </button>
          </form>

          <p className="mt-8 text-center text-midnight-navy/60 text-sm" data-id="element-413" data-mp="ocrgihz2d5eh">
            Already have an account?{' '}
            <Link to="/login" className="font-bold text-royal-blue hover:text-royal-blue-dark transition-colors" data-id="element-414" data-mp="2vwvteraps842">
              Log in
            </Link>
          </p>
        </motion.div>
      </div>

      {/* Right Side - Image */}
      <div className="hidden lg:flex flex-1 bg-midnight-navy relative overflow-hidden items-center justify-center p-12" data-id="element-415" data-mp="2hwupt432emkw">
        <div className="absolute inset-0 opacity-40" data-id="element-416" data-mp="3eliyvawsyzi6">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/9a6ff696-b87b-492d-a00d-c659f58b3532.jpg" alt="Consulting Meeting" className="w-full h-full object-cover" data-id="element-417" data-mp="3akyylygxnfrt" />
          <div className="absolute inset-0 bg-midnight-navy/80 mix-blend-multiply" data-id="element-418" data-mp="30vyygbqp2ec1" />
        </div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative z-10 max-w-lg space-y-8" data-id="element-419" data-mp="25f8377ncbgg">
          <div className="w-12 h-12 bg-royal-blue rounded-xl flex items-center justify-center shadow-xl shadow-royal-blue/20" data-id="element-420" data-mp="4qwpy7jf6q1u">
            <svg className="w-6 h-6 text-stark-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-421" data-mp="9qsovsd9fraj">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-422" data-mp="iqxqtmzopxhb" />
            </svg>
          </div>
          <blockquote className="text-3xl font-montserrat font-bold text-stark-white leading-tight" data-id="element-423" data-mp="xeiwnony2asx">
            "The operational assessment alone paid for itself. They rebuilt our
            purchasing process."
          </blockquote>
          <div data-id="element-424" data-mp="16ga0enyxc7k5">
            <div className="text-stark-white font-bold" data-id="element-425" data-mp="16gjou74bm6nq">Marcus Bell</div>
            <div className="text-stark-white/60 text-sm" data-id="element-426" data-mp="1bf3g8n1ooanh">
              VP of Operations, Harbor Hospitality Group
            </div>
          </div>
        </motion.div>
      </div>
    </main>;
}